(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["novaire-pdp-extras"] && !Shopify.designMode) return;
  try {
    function novaireBindPdp() {
  document.querySelectorAll('fieldset').forEach((fieldset) => {
    const legend = fieldset.querySelector('legend');
    if (legend && legend.textContent.trim() === 'Stone') fieldset.hidden = true;
    if (
      legend &&
      legend.textContent.trim() === 'Style' &&
      /diamond-cross-necklace-with-clavicle-chain/.test(window.location.pathname)
    ) {
      fieldset.hidden = true;
    }
  });

  document.querySelectorAll('[data-novaire-guide-open]').forEach((button) => {
    if (button.dataset.bound) return;
    button.dataset.bound = 'true';
    button.addEventListener('click', () => {
      const guide = document.querySelector('[data-novaire-guide]');
      if (guide && typeof guide.showModal === 'function') guide.showModal();
    });
  });

  document.querySelectorAll('input[name^="novaire-stone-"]').forEach((input) => {
    if (input.dataset.bound) return;
    input.dataset.bound = 'true';
    input.addEventListener('change', () => {
      const form = document.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      const idInput = form.querySelector('[name="id"]');
      if (!idInput) return;
      idInput.value = input.value;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      idInput.dispatchEvent(new Event('input', { bubbles: true }));
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', novaireBindPdp);
} else {
  novaireBindPdp();
}
  } catch(e) { console.error(e); }
})();

})();
